/* eslint-disable no-underscore-dangle */
import { useState, useEffect } from 'react';

import { LexicalEditor } from 'lexical';
import classNames from 'classnames';

import { Box } from '../../../../../../Box';
import { Typography } from '../../../../../../Typography';
import { DropdownButton } from '../../../../../../DropdownButton';
import { MenuItem } from '../../../../../../MenuItem';
import { QuoteDialog } from '..';

import { useStyles } from './Quote.styles';

interface QuoteProps {
  text: string;
  author?: string;
  editor: LexicalEditor;
  setData: (text: string, author?: string) => void;
  remove: () => void;
}

export const Quote = ({
  text,
  author = '',
  editor,
  setData,
  remove,
}: QuoteProps) => {
  const { classes } = useStyles();

  const [quoteText, setQuoteText] = useState(text);
  const [quoteAuthor, setQuoteAuthor] = useState(author);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isQuoteDialogOpen, setIsQuoteDialogOpen] = useState(false);

  const isEditable = editor.isEditable();
  const classesByCondition =
    isMenuOpen || isQuoteDialogOpen
      ? classNames([classes.menu, classes.activeMenu])
      : classes.menu;

  useEffect(() => {
    setQuoteAuthor(author);
    setQuoteText(text);
  }, [text, author]);

  const handleQuoteDialogOpen = () => {
    setIsQuoteDialogOpen(true);
  };
  const handleQuoteDialogClose = () => {
    setIsQuoteDialogOpen(false);
  };
  const handleMenuOpen = () => {
    setIsMenuOpen(true);
  };
  const handleMenuClose = () => {
    setIsMenuOpen(false);
  };
  const handleSubmit = (authorData: string, textData: string) => {
    editor.update(() => {
      setData(textData, authorData);
    });
  };

  return (
    <>
      <Box className={classes.quote}>
        <Typography className={classes.author} variant="body2">
          {quoteText}
        </Typography>
        {quoteAuthor && (
          <Typography variant="subtitle1">{quoteAuthor}</Typography>
        )}

        {isEditable && (
          <Box className={classesByCondition}>
            <Box position="absolute" top="12px" right="8px">
              <DropdownButton
                onOpen={handleMenuOpen}
                onClose={handleMenuClose}
                size="small"
                variant="quaternary"
                verticalPosition="bottom"
                horizontalPosition="right"
                menuItems={
                  <Box display="flex" flexDirection="column">
                    <MenuItem onClick={handleQuoteDialogOpen}>
                      <Typography variant="body2">Редактировать</Typography>
                    </MenuItem>
                    <MenuItem onClick={remove}>
                      <Typography variant="body2">Удалить</Typography>
                    </MenuItem>
                  </Box>
                }
              />
            </Box>
          </Box>
        )}
      </Box>

      {isQuoteDialogOpen && (
        <QuoteDialog
          editor={editor}
          open={isQuoteDialogOpen}
          onClose={handleQuoteDialogClose}
          selectionText={quoteText}
          authorText={quoteAuthor}
          handleSubmit={handleSubmit}
          edit
        />
      )}
    </>
  );
};
